import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  ShoppingCart,
  Users,
  UserCheck,
  Package,
  PenTool,
  Grid3x3,
  Trophy,
  Receipt,
  IndianRupee,
  ShieldCheck,
  X
} from 'lucide-react';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Orders', href: '/orders', icon: ShoppingCart },
  { name: 'Leads', href: '/leads', icon: Users },
  { name: 'Technicians', href: '/technicians', icon: UserCheck },
  { name: 'Products', href: '/products', icon: Package },
  { name: 'Product Grid', href: '/products/grid', icon: Grid3x3 },
  { name: 'Content Creator', href: '/content-creator', icon: PenTool },
  { name: 'Contests', href: '/contests', icon: Trophy },
  { name: 'Expenses', href: '/expenses', icon: Receipt },
  { name: 'Payments', href: '/payments', icon: IndianRupee },
  { name: 'Users', href: '/users', icon: ShieldCheck },
];

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const location = useLocation();

  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div className="fixed inset-0 z-40 lg:hidden" onClick={onClose}>
          <div className="fixed inset-0 bg-slate-950 bg-opacity-70"></div>
        </div>
      )}

      {/* Sidebar */}
      <div className={`
        fixed top-0 left-0 z-50 h-full w-60 bg-[#111827] shadow-strong transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 border-r border-slate-800
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="flex items-center justify-between h-14 px-5 border-b border-slate-800 bg-[#0f172a]">
          <div className="flex items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-xs font-bold text-white">
              M
            </div>
            <div>
              <h1 className="text-sm font-semibold tracking-wide text-white">Minto Admin</h1>
              <p className="text-[10px] font-medium uppercase tracking-[0.16em] text-slate-500">Operations</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md text-slate-400 hover:text-white hover:bg-slate-800"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <nav className="mt-4 px-3">
          <div className="mb-2 px-3 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            Menu
          </div>
          <div className="space-y-0.5">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href ||
                             (item.href === '/orders' && location.pathname.startsWith('/orders')) ||
                             (item.href === '/products' && location.pathname.startsWith('/products') && !location.pathname.startsWith('/products/grid')) ||
                             (item.href === '/products/grid' && location.pathname.startsWith('/products/grid'));
              const Icon = item.icon;

              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={onClose}
                  className={`
                    sidebar-link w-full
                    ${isActive ? 'active' : ''}
                  `}
                >
                  <Icon className="h-4 w-4 shrink-0" />
                  <span className="truncate">{item.name}</span>
                </Link>
              );
            })}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
